import {
	LexicalComposer,
	InitialConfigType,
} from "@lexical/react/LexicalComposer";
import { Editor } from "../htmlEditor/Editor";
import EditorNodes from "./nodes/EditorNodes";
import PlaygroundEditorTheme from "./themes/PlaygroundEditorTheme";
import { LexicalEditor } from "lexical";
import { TotalAttachmentSizeLimit, AttachmentSizeLimit } from "@/common/constants";

interface LexicalEditorWrapperProps {
	initialHtml: string;
	onChange: (html: string) => void;
	additionalBar?: (editor?: LexicalEditor | undefined) => JSX.Element;
	afterContent?: JSX.Element;
	readOnly?: boolean;
	currentAttachmentsSizeBytes?: number;
	maxTotalAttachmentsSizeBytes?: number;
	maxAttachmentSizeBytes?: number;
	onPaste?: (pastedHtml: string, pastedText: string) => string | null;
	onPastedFiles?: (files: File[]) => void;
}

const initialConfig: InitialConfigType = {
	editorState: undefined,
	namespace: "EmailEditor",
	nodes: [...EditorNodes],
	onError: (error: Error) => {
		throw error;
	},
	theme: PlaygroundEditorTheme,
};

const LexicalEditorWrapper = ({
	initialHtml,
	onChange,
	additionalBar,
	afterContent,
	readOnly,
	currentAttachmentsSizeBytes = 0,
	maxTotalAttachmentsSizeBytes = TotalAttachmentSizeLimit,
	maxAttachmentSizeBytes = AttachmentSizeLimit,
	onPaste,
	onPastedFiles,
}: LexicalEditorWrapperProps) => {
	return (
		<LexicalComposer initialConfig={initialConfig}>
			<Editor
				readOnly={readOnly}
				onChange={onChange}
				initialHtml={initialHtml}
				additionalBar={additionalBar}
				afterContent={afterContent}
				currentAttachmentsSizeBytes={currentAttachmentsSizeBytes}
				maxTotalAttachmentsSizeBytes={maxTotalAttachmentsSizeBytes}
				maxAttachmentSizeBytes={maxAttachmentSizeBytes}
				onPaste={onPaste}
				onPastedFiles={onPastedFiles}
			/>
		</LexicalComposer>
	);
};

export default LexicalEditorWrapper;
